import { onboardingRoutePrefix } from '@provider-portal/common/routing/routes';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton } from '@bolteu/clay-react';
import { ArrowBackward } from '@bolteu/kalep-react-icons';
import { useIsSelectedProviderInOnboarding } from '@provider-portal/common/hooks/useIsSelectedProviderInOnboarding';
import { useIsOnboardingRoute } from '@provider-portal/common/routing/hooks';

export function ReturnToOnboardingLink() {
  const isSelectedProviderInOnboarding = useIsSelectedProviderInOnboarding();
  const isOnboardingRoute = useIsOnboardingRoute();

  if (!isSelectedProviderInOnboarding) {
    return null;
  }

  if (isOnboardingRoute) {
    return null;
  }

  return (
    <RouterLink to={onboardingRoutePrefix}>
      <div className="mt-1 mb-4 flex">
        <IconButton variant="secondary" size="lg" icon={<ArrowBackward />} />
      </div>
    </RouterLink>
  );
}
